// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "index." + "c4359ba1cc772749c151" + ".css";
};